import React, { Suspense, lazy } from 'react';

import LoadingIndicator from '@swf/components/LoadingIndicator/LoadingIndicator';
import useImagePreloader from '@swf/sports/hooks/useImagePreloader';

import backgroundImage from './Maintenance/assets/maintenance-pss.jpg';
import styles from './SportsMaintenance.scss';

const Maintenance = lazy(() => import('./Maintenance/Maintenance'));

export const SportsMaintenance = () => {
  const { imagesPreloaded } = useImagePreloader([backgroundImage]);

  const loader = <LoadingIndicator loading variant="light" className={styles.loading} />;

  return imagesPreloaded ? (
    <Suspense fallback={loader}>
      <Maintenance />
    </Suspense>
  ) : (
    loader
  );
};

export default SportsMaintenance;
